


















































import {Component, Vue} from 'vue-property-decorator';
import {UserModule, UserStore} from "@/store/modules/currentuser-store";
import {GlobalHelper} from "@/helper/global-helper";
import { SystemMode } from '@/services/systemmode';
import { GuardileoVueComponent } from '@/lib';

@Component
export default class AngabenUnternehmen extends GuardileoVueComponent {
    public userStore: UserModule = UserStore;
    public showAccessErrorNoti: Function = GlobalHelper.NotifyAccessError;
    private mode: SystemMode = {} as any;

    async created() {
        this.mode = (<any>window).guardileo_mode;
    }

    get darf_kundenstammblatt_verwalten(): boolean {
        return this.hat_Berechtigung('Kundenstammblatt_bearbeiten');
    }
}
